var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-banner"},[_c('div',{staticClass:"d-flex banner"},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("mdi-alert-circle-outline")]),_c('span',{staticClass:"edit-description"},[_vm._v(_vm._s(_vm.editDescription))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }